import styled from 'styled-components';

export const ChipsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${({ theme }) => `
        margin: 0 -${theme.spacing(0.5)}px -${theme.spacing(1)}px;
        > * {
            margin: 0 ${theme.spacing(0.5)}px ${theme.spacing(1)}px;
        }
    `}
`;